<template>
  <sidebar-content submitLabel="Enviar" hideSubmit :open="openModal" @close="closeModal">
    <v-container grid-list-lg class="px-2 py-0" v-resize="onResize" :style="setHeightScroll">
      <v-form v-model="valid" class="" ref="form"  lazy-validation>
        <v-layout wrap>
          <v-flex xs12 sm12>
             <v-switch
              class=""
              disabled
              v-model="showModal"
              label="Dados inteligentes"
            ></v-switch>
          </v-flex>
          <v-flex xs12 sm6>
            <v-select
              item-value="id"
              item-text="name"
              v-model="newMultiplesCases.costCenter"
              required :rules="validate.requiredRules"
              :items="itemsCost"
              label="Centro de Custo"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout wrap column>
          <v-flex xs12 sm12>
            <p class="darkGray--text">Notificações:</p>
            <v-radio-group v-model="newMultiplesCases.type" row required :rules="validate.requiredRules">
              <v-radio label="Auto de Constatação" value="auto_constatacao"></v-radio>
              <v-radio label="Auto de Infração" value="auto_infracao"></v-radio>
            </v-radio-group>
          </v-flex>
          <v-flex xs12 sm12>
            <v-layout wrap>
              <v-flex xs12 sm4>
                <card-checked
                  title="Carta"
                  color="secondary"
                  displayMode
                  icon="email"
                  :checked="letterChecked"
                  @change="changeLetter"
                  >
                  <v-radio-group
                    :rules="validate.requiredRules"
                    required
                    @change="changeLetterOptions"
                    v-model="radioGroup"
                  >
                    <v-radio
                      color="secondary"
                      class="label-small-size"
                      v-for="(option, index) in letterOptions"
                      :key="`${option}-${index}`"
                      :label="option.label"
                      :value="option" >
                    </v-radio>

                  </v-radio-group>

                </card-checked>
              </v-flex>
              <v-flex xs12 sm4>
                <card-checked
                  title="SMS"
                  displayMode
                  color="accent"
                  icon="textsms"
                  :checked="smsChecked"
                  >
                </card-checked>
              </v-flex>
              <v-flex xs12 sm4>
                <card-checked
                  title="E-mail"
                  displayMode
                  color="accent"
                  icon="mdi-at"
                  :checked="emailChecked"
                  >
                </card-checked>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12>

            <input-file
              label="Enviar arquivo"
              required
              :rules="validate.requiredRules"
              @fileData="parse"
            ></input-file>

            <v-btn
              @click="send"
              class="btn-fixed"
              block
              :disabled="!valid"
              :loading="isLoading"
              color="accent"
              depressed
              >
              Importar dados
            </v-btn>

          </v-flex>
        </v-layout>
      </v-form>
      <modal
        :show="showModal"
        @close="closeModal"
        @submit="saveModal"
        >

        <template v-slot:title>título do modal </template>
        <template v-slot:content>
          <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Rem sunt sequi laudantium id consequatur, dolor obcaecati, ut architecto enim dicta inventore. Omnis fugit, vel similique suscipit. Omnis nostrum, iure officia.</p>
        </template>
      </modal>
    </v-container>
  </sidebar-content>
</template>

<script>
  import InputFile from '@/components/ui/InputFile'
  import CardChecked from '@/components/ui/CardChecked'
  import Modal from '@/components/ui/Modal'
  import SidebarContent from '@/components/ui/SidebarContent'
  import resizing from '@/utils/resizing'
  import md5 from 'js-md5'
  import Papa from 'papaparse'
  import { uuid } from 'vue-uuid'
  import { setTimeout } from 'timers';

  export default {
    name: 'NewMultiplesRecipient',
    components: { InputFile, CardChecked, Modal, SidebarContent },
    mixins: [ resizing ],
    data () {
      return {
        type: '',
        openModal: false,
        showModal: false,
        // TODO: componentize
        radioGroup: null,
        letterChecked: true,
        emailChecked: false,
        smsChecked: false,
        valid: true,
        itemsCost: [
          {
            id: 'arrecadacao',
            name: 'Arrecadação'
          },
          {
            id: 'divida_ativa',
            name: 'Dívida Ativa'
          },
          {
            id: 'fiscalizacao',
            name: 'Fiscalização'
          }
        ],
        linesProcessed: null,
        newMultiplesCases: {
          type: '',
          fileName: '',
          fileSize: '',
          costCenter: '',
          md5: '',
          totalCount: '',
          state: 'processed',
          comunications: {
            letter: {
              type: ''
            }
          },
          insertedAt: ''
        },
        letterOptions: [
          {
            label: 'Simples',
            value: 'simple'
          },
          {
            label: 'Registrados',
            value: 'registered'
          },
          {
            label: 'AR',
            value: 'simple_ar'
          },
          {
            label: 'AR mãos próprias',
            value: 'hand_ar'
          }
        ]
      }
    },
    methods: {
      parse (data) {
        Papa.parse(data.content, {
          header: true,
          delimiter: '',
          trimHeaders: true,
          dynamicTypinparseg: false,
          skipEmptyLines: true,
          complete: results => {
            let lines = JSON.stringify(results.data, null, 2)
            this.linesProcessed = results.data
            this.newMultiplesCases.md5 = md5(lines)
            this.newMultiplesCases.fileSize = data.size
            this.newMultiplesCases.fileName = data.filename
            this.newMultiplesCases.totalCount = results.data.length
            this.newMultiplesCases.insertedAt = this.firebase.firestore.FieldValue.serverTimestamp()
          },
          error (errors) {
            console.log('error', errors)
          }
        })
      },
      send () {
        if (this.$refs.form.validate()) {
          this.$store.commit('global/setLoading', true)

          this.firebase.auth().currentUser.getIdTokenResult().then(async result => {
            const db = this.firebase.firestore()
            const storage = this.firebase.storage().ref()
            const currentCompany = result.claims.currentCompany
            const companyPath = `companies/${currentCompany}`
            const recipientPath = `${companyPath}/recipients`
            const batchId = uuid.v4()
            const storageRef = storage.child(`${companyPath}/batches/${batchId}.json`)

            this.linesProcessed = this.linesProcessed.map(line => ({
              ...line,
              type: this.newMultiplesCases.type,
              comunications: this.newMultiplesCases.comunications
            }))

            const metadata = {
              contentType: 'application/json',
              contentEncoding: 'base64',
              customMetadata: {
                type: 'batches',
                currentCompany: currentCompany,
                batchId: batchId
              }
            }

            const storageContent = new Blob([JSON.stringify(this.linesProcessed)], {
              type: 'application/json'
            })

            this.newMultiplesCases = { ...this.newMultiplesCases, fileName: storageRef.name, filePath: storageRef.fullPath }

            storageRef.put(storageContent, metadata).then(async () => {
              await db.collection(`${companyPath}/batches`).doc(batchId).set(this.newMultiplesCases)
               this._success()
            })
          })
        }
      },
      _success () {
        setTimeout(() => {
          this.$store.commit('global/setLoading', false)
          this.$nextTick(() => {
            this.$root.$emit('snackbar', {show: true, color: 'success', text: 'Importação de dados'})
            this.$router.push({ name: 'RecipientMultiples' })
          })
        }, 1000)
      },
      changeLetter (isChecked) {
        // this.letterChecked = isChecked
      },
      changeLetterOptions (options) {
        this.newMultiplesCases.comunications.letter.type = options.value
      },
      closeModal () {
        this.showModal = false
      },
      saveModal () {
        console.log('salvando conteudo do modal')
      },
      showSidebar () {
        this.openModal = true
      },
      closeModal () {
        this.openModal = false
        this.$router.push({ name: 'RecipientMultiples' })
      },
    },
    computed: {
      isLoading () {
        return this.$store.state.isLoading
      }
    },
    mounted () {
      this.showSidebar()
    }
  }
</script>



